module.exports = __webpack_public_path__ + "static/img/operateWeek.0b8cedd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateWeek.png
// module id = ThUQ
// module chunks = 1